const w = (e) => e != null, f = (e) => typeof e == "function", u = (e) => f(e) ? e() : e, h = (e, ...r) => r.some((t) => typeof e === t), d = (e, r) => r in e, l = (e, r) => e instanceof r, m = (...e) => (r) => e.reduceRight((t, o) => o(t), r), p = (...e) => (r) => e.reduce((t, o) => o(t), r), D = (e) => (...r) => Promise.resolve(e(...r)), T = (e) => (r) => {
  try {
    return e();
  } catch (t) {
    return r ? r(t) : t;
  }
}, x = (e) => async (r) => {
  try {
    return await e();
  } catch (t) {
    return r ? r(t) : t;
  }
}, k = async (e, r) => {
  var i;
  const t = {
    delay: 300,
    retries: 2,
    ...r
  };
  let o;
  for (let n = 1; n <= t.retries; n++)
    try {
      return await e();
    } catch (s) {
      if (o = s, (i = t.shouldSkip) != null && i.call(t, s)) throw s;
      n < t.retries && await new Promise((a) => setTimeout(a, (t.delay ?? 300) * n));
    }
  throw o;
}, E = (e, r) => {
  let t = Date.now();
  const o = async (i = 1) => {
    var a;
    const n = {
      initialDelay: 300,
      maxDelay: 5e3,
      retries: 3,
      resetTime: 1e4,
      // 10s
      ...r
    }, s = Date.now();
    s - t > n.resetTime && (i = 1), t = s;
    try {
      return await e();
    } catch (c) {
      if (n.onError && await n.onError(c), (a = n.shouldSkip) != null && a.call(n, c) || n.retries !== -1 && i >= n.retries) throw c;
      return n.onRetry && await n.onRetry(c, i), new Promise(
        (y) => setTimeout(
          async () => y(o(i + 1)),
          Math.min(n.initialDelay * 2 ** (i - 1), n.maxDelay)
        )
      );
    }
  };
  return o();
}, P = (e) => (r) => (...t) => e(t) ? r(t) : void 0, R = () => typeof window < "u";
export {
  m as compose,
  P as ifThen,
  w as isDefined,
  f as isFunction,
  l as isInstanceOf,
  d as isType,
  h as isTypeof,
  u as orFn,
  p as pipe,
  D as promisify,
  k as retry,
  E as retryWithBackoff,
  T as tryCatch,
  x as tryCatchAsync,
  R as windowDefined
};
